import styled, { css } from 'styled-components'
import { ZIndexRange } from '../types/enums'
import { overloadColor } from '../util/style'

interface WrapperProps {
  width: string
  height: string
  zIndex: number
  background?: string

  imageSize: string
  imageBackgroundColor: string

  popup: boolean
  open?: boolean
}
export const Wrapper = styled.div<WrapperProps>`
  box-sizing: border-box;
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props => props.width};
  height: ${props => props.height};
  z-index: ${props => props.zIndex};

  overflow: hidden;
  background: ${props => props.background && overloadColor(props.background)};

  ${props =>
    props.popup &&
    css`
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;

      display: ${props.open ? 'flex' : 'none'};
    `}

  img {
    position: absolute;
    max-width: 100vw;
    max-height: 100%;
    object-fit: ${props => props.imageSize};
    background-color: ${props => overloadColor(props.imageBackgroundColor)};
  }
`

interface ImageDescriptionProps {
  opacity: number
  width?: string
  marginBottom?: string
  color: string
  background: string
}
export const ImageDescription = styled.div<ImageDescriptionProps>`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: ${props => props.width};
  margin: 0 auto;
  margin-bottom: ${props => props.marginBottom};
  padding: 12px 0;

  color: ${props => overloadColor(props.color)};
  background-color: ${props => overloadColor(props.background)};

  opacity: ${props => props.opacity};
  transition: opacity 0.2s linear;

  p {
    margin: 4px 0 0 0;
    font-size: 0.8rem;
  }
`

interface NavArrowsProps {
  leftVisible: boolean
  rightVisible: boolean
}
export const NavArrows = styled.div<NavArrowsProps>`
  position: absolute;
  z-index: ${ZIndexRange.Globals};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  touch-action: none;

  div {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    padding: 1rem 1rem 0.8rem;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 8px;

    cursor: pointer;
    pointer-events: auto;
    touch-action: auto;
    transition: background-color 0.2s ease-out;

    i {
      font-size: 4rem;
      color: rgba(255, 255, 255, 0.4);
      transition: color 0.2s ease-out;
    }
    &:hover {
      background-color: black;

      i {
        color: rgba(255, 255, 255, 0.8);
      }
    }
    &.--image-viewer-nav-arrows-left {
      left: 20px;
      display: ${props => !props.leftVisible && 'none'};
    }
    &.--image-viewer-nav-arrows-right {
      right: 20px;
      display: ${props => !props.rightVisible && 'none'};
    }
  }
`

interface CounterProps {
  opacity: number
}
export const Counter = styled.div<CounterProps>`
  position: absolute;
  z-index: 10;
  bottom: 10px;
  right: 0;
  padding: 6px 8px 6px 10px;

  user-select: none;
  pointer-events: none;
  touch-action: none;

  border-radius: 8px 0 0 8px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  font-size: 0.8rem;

  opacity: ${props => props.opacity};
  transition: opacity 0.2s linear;

  span {
    color: #777;
  }
`

export const DownloadButton = styled.div.attrs({
  role: 'button',
})`
  position: absolute;
  z-index: ${ZIndexRange.Globals + 1};
  top: 16px;
  left: 16px;
`

export const CloseButton = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: ${ZIndexRange.Globals + 1};
`
